import React from "react";
import { VARIATIONS } from "../lib/constants";

export const DefaultQuickCompare = ({ quickCompare }) => {
    return (
        <div className="compare-buttons">
            {Object.values(VARIATIONS).map((name) => {
                return (
                    <div
                        style={{ display: "inherit" }}
                        key={name}
                    >
                        <button
                            className="link -separator"
                            onClick={() => quickCompare(name, name)}
                        >
                            {name}
                        </button>
                        <div className="separator" />
                    </div>
                );
            })}
        </div>
    );
};
